export default __webpack_public_path__ + "static/media/marketing.0c0e7f6f.svg";